/**
* @Author: zachalam
* @Date:   2017-01-19T17:15:26-08:00
* @Last modified by:   zachalam
* @Last modified time: 2017-01-19T17:15:58-08:00
*/

import React, { Component } from 'react';
import Profile from '../components/pages/Profile/Profile';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import { refreshProfile, refreshExternalProfile, toggleBlockProfile, toggleBlockInStore } from '../actions/profileActions';
import { storeProfileFavChange, favToggle } from '../actions/favActions';
import { joinTrip, joinTripStore } from '../actions/tripActions';

class ProfileContainer extends Component {


  refreshProfile(username) {
    //console.log("refreshing profile");
    //console.log(username);
    this.props.refreshExternal(username);

  }

  componentWillMount() {
    //console.log("componentWillMount");
    this.refreshProfile(this.props.params.username);
  }

  componentWillUpdate(nextProps) {

    if(nextProps.params.username != this.props.params.username) {
      this.refreshProfile(nextProps.params.username);
    }
  }



  render() {


    return (
      <Profile {...this.props} />

    );

  }
}

const mapStateToProps = (state) => {
  return {
    myprofile: state.profile,
    profile: state.extprofile,
  }
};

// actions to refresh internal/external profile.
const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    refreshExternal(username) {
      return dispatch(refreshExternalProfile(username));
    },
    toggleFav: (username) => {
      // notify extprofile store
      dispatch(storeProfileFavChange());
      // notify api.
      dispatch(favToggle(username));
    },
    joinTrip: (tripId,tripKey) => {
      // notify store
      dispatch(joinTripStore(tripKey));
      // notify api.
      dispatch(joinTrip(tripId));
    },
    toggleBlock: (username) => {
      // notify store.
      dispatch(toggleBlockInStore(username));
      // notify api.
      dispatch(toggleBlockProfile(username));
    }
  }
}

export default connect(mapStateToProps,mapDispatchToProps)(ProfileContainer);



// WEBPACK FOOTER //
// ./src/containers/ProfileContainer.jsx